import axios, {AxiosResponse} from 'axios'
 import { HTTPResponseModel } from '../../../../../common/models/HTTPResponseModel'
import {PutUsageCriteriaModel, PutUsageMaterielModel, PutUsageOptionModel} from "./model";

const API_URL = process.env.REACT_APP_API_URL

const LIST_USAGE_FLOOR = `${API_URL}usage/ListUsageFloor`;
const GET_USAGE_CRITERE = `${API_URL}usage/GetUsageCriteria`//usage/GetUsageCriteria
const PUT_USAGE_CRITERE = `${API_URL}usage/PutUsageCriteria`
const GET_LIST_USAGE_OPTION = `${API_URL}usage/ListUsageOption`
const GET_LIST_USAGE_MATERIAL_MOTEUR = `${API_URL}usage/ListUsageMaterial`
const PUT_USAGE_OPTION = `${API_URL}usage/PutUsageOption`
const PUT_USAGE_MATERIAL = `${API_URL}usage/PutUsageMaterial`

export const getListFloor = async (
    data: any,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(LIST_USAGE_FLOOR, {
        params : data
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getListFloor(data, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}

export const getUsageCriteria = async (
    Guid: String,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(GET_USAGE_CRITERE, {
       params: {
           Guid: Guid
       }
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getUsageCriteria(Guid, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}

/**
 *
 * @param Guid
 * @param onAccessLost
 * @param onToastOrMessage
 * @description option material
 */
export const getListUsageOption = async (
    Guid: String,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(GET_LIST_USAGE_OPTION, {
        params: {
            Guid: Guid
        }
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getListUsageOption(Guid, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}


/**
 *
 * @param Guid
 * @param onAccessLost
 * @param onToastOrMessage
 * @description Liste materiel moteur
 */
export const getListMaterielMoteur = async (
    Guid: String,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(GET_LIST_USAGE_MATERIAL_MOTEUR, {
        params: {
            Guid: Guid
        }
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getListUsageOption(Guid, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}


/**
 *
 * @param Guid
 * @param onAccessLost
 * @param onToastOrMessage
 * @description put usage critere , codition usage declencher via button recherche
 */
export const putUsageCritere = async (
    data: PutUsageCriteriaModel,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.put<HTTPResponseModel>(PUT_USAGE_CRITERE,data)
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await putUsageCritere(data, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}

/**
 *
 * @param data PutUsageOptionModel
 * @param onAccessLost
 * @param onToastOrMessage
 * @description put A chaque cochage/décochage d'une "Option matériel"
 */
export const putUsageOption = async (
    data: PutUsageOptionModel,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.put<HTTPResponseModel>(PUT_USAGE_OPTION,data)
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await putUsageOption(data, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}

/**
 *
 * @param data PutUsageOptionModel
 * @param onAccessLost
 * @param onToastOrMessage
 * @description put A chaque cochage/décochage d'une "Option matériel"
 */
export const putUsageMaterial = async (
    data: PutUsageMaterielModel,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.put<HTTPResponseModel>(PUT_USAGE_MATERIAL,data)
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await putUsageMaterial(data, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}






